import { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import api from "../../../BrandOnBoarding/api";

export default function useHistory(email, type) {
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const [error, setError] = useState("");
  const [hasReachedEnd, setHasReachedEnd] = useState(false);

  const abortCtrlRef = useRef();

  useEffect(() => {
    if (abortCtrlRef.current) {
      abortCtrlRef.current.abort();
    }
    setHistory([]);
    setHasReachedEnd(false);
  }, [type]);

  async function getHistory(page = 1, limit = 5) {
    try {
      setError("");
      setLoading(true);
      if (abortCtrlRef.current) {
        abortCtrlRef.current.abort();
      }
      const abortCtrl = new AbortController();
      abortCtrlRef.current = abortCtrl;

      const response = await api.get(
        `/users/content-map-history?user_email=${encodeURIComponent(email)}&page=${page}&limit=${limit}&type=${type}&is_conversations=true`,
        { signal: abortCtrlRef.current.signal }
      );
      setLoading(false);
      if (response.status !== 200) {
        setError("Failed to fetch history");
        return;
      }
      const data = response.data;
      if (data.data.length === 0 || data.data.length < limit) {
        setHasReachedEnd(true);
      }
      const newHistory = data.data.map((item) => {
        return {
          ...item,
          market: item?.json_data?.market,
        };
      });

      setHistory((prev) => {
        return [...prev, ...newHistory];
      });
    } catch (error) {
      if (error.name === "CanceledError") {
        return;
      }
      setError("Failed to fetch history");
      setLoading(false);
    }
  }

  async function deleteHistory(id) {
    try {
      const response = await api.delete(`/users/content-map-history/${id}`);
      if (response.status === 200) {
        setHistory((prevHistory) => {
          const updatedHistory = prevHistory.filter(
            (history) => history.id !== id
          );
          return updatedHistory;
        });
      } else {
        toast.error("Failed to delete history");
      }
    } catch (error) {
      toast.error("Failed to delete history");
    }
  }

  async function updateHistory(id, name, json_data) {
    const itemIndex = history.findIndex((item) => item.id === id);
    try {
      const response = await api.patch(`/users/content-map-history/${id}`, {
        name,
        json_data,
      });
      if (response.status !== 200) {
        toast.error("Failed to update history");
        throw error;
      }
      if (response.status === 200) {
        setHistory((prevHistory) => {
          const updatedHistory = [...prevHistory];
          if (itemIndex > -1) {
            updatedHistory[itemIndex] = {
              ...updatedHistory[itemIndex],
              name: name,
            };
          }
          return updatedHistory;
        });
      }
    } catch (error) {
      toast.error("Failed to update history");
      throw error;
    }
  }

  async function addHistory(data) {
    try {
      const response = await api.post(`/users/content-map-history`, data);
      if (response.status === 201) {
        setHistory((prevHistory) => {
          return [response.data.data, ...prevHistory];
        });
      } else {
        toast.error("Failed to save history");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to save history");
    }
  }

  return {
    loading,
    error,
    history,
    getHistory,
    deleteHistory,
    updateHistory,
    addHistory,
    hasReachedEnd,
  };
}
